import { ColumnDataType, TableColumn } from "@cotecna/tables";

export const DATA_INPUT_TABLE_COLUMNS_GENERAL_INFO: TableColumn[] = [
  {
    dataProperty: "dateTime",
    isSorting: true,
    label: "Date/Time",
    dataType: ColumnDataType.DateTime,
    width: 0,
  },
  {
    dataProperty: "author",
    isSorting: true,
    label: "Author",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "section",
    isSorting: true,
    label: "Section",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "fieldName",
    isSorting: true,
    label: "Field Name",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "newValue",
    isSorting: true,
    label: "New Value",
    dataType: ColumnDataType.StringOrImage,
    width: 0,
  },
];

export const DATA_INPUT_TABLE_COLUMNS_ITEMS: TableColumn[] = [
  {
    dataProperty: "dateTime",
    isSorting: true,
    label: "Date/Time",
    dataType: ColumnDataType.DateTime,
    width: 0,
  },
  {
    dataProperty: "author",
    isSorting: true,
    label: "Author",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "itemName",
    isSorting: true,
    label: "Item Name",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "section",
    isSorting: true,
    label: "Section",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "subSection",
    isSorting: true,
    label: "Sub-Section",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "fieldName",
    isSorting: true,
    label: "Field Name",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "newValue",
    isSorting: true,
    label: "New Value",
    dataType: ColumnDataType.StringOrImage,
    width: 0,
  },
];

export const DATA_INPUT_TABLE_COLUMNS_SCOPE_OF_WORK: TableColumn[] = [
  {
    dataProperty: "dateTime",
    isSorting: true,
    label: "Date/Time",
    dataType: ColumnDataType.DateTime,
    width: 0,
  },
  {
    dataProperty: "author",
    isSorting: true,
    label: "Author",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "section",
    isSorting: true,
    label: "Section",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "subSection",
    isSorting: true,
    label: "Sub-Section",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "fieldName",
    isSorting: true,
    label: "Field Name",
    dataType: ColumnDataType.String,
    width: 0,
  },
  {
    dataProperty: "newValue",
    isSorting: true,
    label: "New Value",
    dataType: ColumnDataType.StringOrImage,
    width: 0,
  },
];
